import { render, staticRenderFns } from "./FragmentVideo.vue?vue&type=template&id=51427b35&scoped=true"
import script from "./FragmentVideo.vue?vue&type=script&lang=ts"
export * from "./FragmentVideo.vue?vue&type=script&lang=ts"
import style0 from "./FragmentVideo.vue?vue&type=style&index=0&id=51427b35&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51427b35",
  null
  
)

export default component.exports